module.exports = __webpack_public_path__ + "static/media/skyscout-monocular-logo.84bf5d8d.jpg";